"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _FlexRelatedAuto = _interopRequireDefault(require("../FlexRelatedAuto"));
var _SceneInromobile = _interopRequireDefault(require("./SceneInromobile"));
var _utils = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-require-imports */

// import  FlexRelated  from '../../FlexRelated';

var _a = require('@tencent/ixd-icons-react/dist'),
  Icon = _a.Icon,
  SuccessIcon = _a.SuccessIcon;
function index(props) {
  var isBigPicRight = props.isBigPicRight,
    flexTitle = props.flexTitle,
    BigImage = props.BigImage,
    handleClickPic = props.handleClickPic,
    firstTitle = props.firstTitle,
    secondTitle = props.secondTitle,
    thirdTitle = props.thirdTitle,
    secondList = props.secondList,
    onepartDesc = props.onepartDesc,
    clickPicTxt = props.clickPicTxt,
    clickPicTxtColor = props.clickPicTxtColor,
    thirdList = props.thirdList,
    backgroundThirdImage = props.backgroundThirdImage,
    backgroundUrl = props.backgroundUrl,
    extendProps = props.extendProps;
  var formatBackgroundUrl = (0, _utils.fomateFileData)(backgroundUrl).url;
  var _a = (0, _utils.fomateFileData)(BigImage),
    bigImage = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var _c = (0, _utils.fomateFileData)(handleClickPic),
    newHandleClickPic = _c.url,
    _d = _c.alt,
    handleClickPicAlt = _d === void 0 ? '' : _d;
  var _e = (0, _react.useState)(false),
    isShow = _e[0],
    setIsShow = _e[1];
  var handleShowPic = function handleShowPic() {
    setIsShow(!isShow);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'aduio-video-sceneintroduce-container',
    style: formatBackgroundUrl ? {
      background: "url(" + formatBackgroundUrl + ") center no-repeat ",
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-wrap'
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: 'aduio-video-sceneintroduce-bigtitle',
    style: flexTitle ? {
      paddingBottom: 40
    } : {
      paddingBottom: 0
    }
  }, flexTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-main'
  }, !isBigPicRight && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('aduio-video-sceneintroduce-imgwrap', {
      'img-left': !isBigPicRight
    })
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: 'aduio-video-sceneintroduce-big-img',
    src: bigImage,
    alt: alt
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-content'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-content-onepart'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'onepart-title'
  }, firstTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'onepart-desc'
  }, onepartDesc), clickPicTxt && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'onepart-href'
  }, /*#__PURE__*/_react["default"].createElement("span", __assign({
    onClick: handleShowPic,
    style: {
      color: clickPicTxtColor
    }
  }, extendProps || {}), clickPicTxt)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-content-secondpart'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'secondpart-title'
  }, secondTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'secondpart-desc'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'secondpart-desc-ul'
  }, secondList === null || secondList === void 0 ? void 0 : secondList.map(function (item, index) {
    var txt = (item || {}).txt;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: 'secondpart-desc-li'
    }, /*#__PURE__*/_react["default"].createElement(SuccessIcon, {
      style: {
        color: clickPicTxtColor
      }
    }), txt);
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'aduio-video-sceneintroduce-content-thirdpart'
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'thirdpart-title'
  }, thirdTitle), /*#__PURE__*/_react["default"].createElement(_FlexRelatedAuto["default"], {
    thirdList: thirdList,
    backgroundThirdImage: backgroundThirdImage
  }))), isBigPicRight && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('aduio-video-sceneintroduce-imgwrap', {
      'img-right': isBigPicRight
    })
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: 'aduio-video-sceneintroduce-big-img',
    src: bigImage,
    alt: alt
  })))))), /*#__PURE__*/_react["default"].createElement(_SceneInromobile["default"], __assign({}, props)), isShow && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'architecturePic'
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    name: "close",
    className: 'icon',
    onClick: handleShowPic
  }), /*#__PURE__*/_react["default"].createElement("img", {
    src: newHandleClickPic ? newHandleClickPic : 'https://test-staticintl.cloudcachetci.com/cms/backend-cms/VSLU252_%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_16508696385265.png',
    alt: handleClickPicAlt
  }))));
}